import React, { useMemo } from 'react';

const AddressLoaderRow = ({ headCells }: any) => {
    const tableCells = useMemo(
        () => [
            {
                key: 'companyName',
                htmlDynamic: (
                    <td className="max-w-px min-w-[170px]">
                        <div className="flex items-center">
                            <div className="text-grayLight900 font-medium custom-loading">Lorem ipsum dolor</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'addressType',
                htmlDynamic: (
                    <td className="max-w-[9.15%] min-w-[140px]">
                        <div className="flex items-center">
                            <div className="custom-loading rounded-md">Lorem ipsum</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'fullAddress',
                htmlDynamic: (
                    <td className="max-w-px min-w-[270px]">
                        <div className="flex items-center">
                            <div className="custom-loading">Lorem ipsum dolor sit amet</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'contactName',
                htmlDynamic: (
                    <td className="max-w-px min-w-[170px]">
                        <div className="flex items-center">
                            <div className="custom-loading">Lorem ipsum dolor</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'contactNumber',
                htmlDynamic: (
                    <td className="max-w-[9.15%] min-w-[170px]">
                        <div className="flex items-center">
                            <div className="custom-loading">Lorem ipsum dol</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'additionalServices',
                htmlDynamic: (
                    <td className="max-w-[9.15%] min-w-[160px]">
                        <div className="flex items-center">
                            <div className="custom-loading">Lorem</div>
                        </div>
                    </td>
                ),
            },
        ],
        []
    );

    const checkboxSkeleton = (
        <td className="w-[40px] min-w-[40px] max-w-[40px] sticky left-0 bg-inherit z-[1] table-cell-with-tooltip">
            <div className="table-col-tooltip-space-common-xs flex items-center h-full">
                <div className="custom-loading w-4 h-4 rounded flex-none" />
            </div>
        </td>
    );

    const actionSkeleton = (
        <td className="min-w-[64px] w-[64px] max-w-[64px] sticky right-0 bg-inherit z-[1] table-cell-with-tooltip">
            <div className="flex items-center justify-end gap-1.5 h-full table-col-tooltip-space-common-xs">
                <div className="custom-loading w-4 h-4 rounded flex-none" />
                <div className="custom-loading w-4 h-4 rounded flex-none" />
            </div>
        </td>
    );

    if (!headCells || headCells.length === 0) {
        return (
            <>
                {tableCells.map((cell) => (
                    <React.Fragment key={cell.key}>{cell.htmlDynamic}</React.Fragment>
                ))}
                {actionSkeleton}
            </>
        );
    }

    return (
        <>
            {headCells
                .filter((cell: any) => cell.visible)
                .map((cell: any) => {
                    if (cell.id === 'checkbox') {
                        return <React.Fragment key="checkbox">{checkboxSkeleton}</React.Fragment>;
                    }

                    if (cell.id === 'action') {
                        return <React.Fragment key="action">{actionSkeleton}</React.Fragment>;
                    }

                    const matched = tableCells.find((tCell) => tCell.key === cell.id);
                    if (!matched) return null;

                    return <React.Fragment key={cell.id}>{matched.htmlDynamic}</React.Fragment>;
                })}
        </>
    );
};

export default AddressLoaderRow;
